import { render, staticRenderFns } from "./reject-button.vue?vue&type=template&id=05594a56&"
import script from "./reject-button.vue?vue&type=script&lang=js&"
export * from "./reject-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports